import type { QueryClient } from '@tanstack/react-query';
import { runInBackground } from '@/lib/utils';
import { useAuthStore } from '@/store/auth';
import { invalidateSessionSensitiveRequests } from '@/lib/sessionSensitiveRequestManager';

export interface EffectiveSessionRefreshLogger {
    error: (message: string, err: unknown) => void;
}

export function resetReactQueryAfterRoleSwitch(
    queryClient: QueryClient,
    log: EffectiveSessionRefreshLogger
): void {
    useAuthStore.getState().beginEffectiveSessionRefresh();
    invalidateSessionSensitiveRequests();

    runInBackground(
        (async () => {
            await queryClient.cancelQueries();
            queryClient.removeQueries({ queryKey: ['profile'] });
            queryClient.removeQueries({ queryKey: ['activeRoleAssignment'] });
            queryClient.removeQueries({ queryKey: ['impersonationContext'] });
            await queryClient.resetQueries({ predicate: () => true });
        })(),
        (err) => {
            log.error('Error resetting queries after effective session change', err);
        }
    );
}
